import { Popover, Button } from "antd"
import { UploadButtonForm, StatefulUploadButtonForm } from ".."
import { PaperClipOutlined, UploadOutlined, FilePdfOutlined  } from "@ant-design/icons"
import { toFileList } from "../../../helpers"
import PropTypes from "prop-types"

UploadTooltip.propTypes = {
  body: PropTypes.string,
  small: PropTypes.bool,
  title: PropTypes.string,
  readOnly: PropTypes.bool,
  value: PropTypes.string,
  stateful: PropTypes.bool
}
export function UploadTooltip ({ isExpenseReconciliation = false ,body, small, title, readOnly, value, stateful = false, ...props }) {
  const content = (
    <div style={{ width: "300px" }}>
      <p>
        {body}
      </p>
      {
        /* The propery stateful may be change the upload button form for the stateful version
        *  This is useful when you need to change the fileList ouside the button form
         */
        stateful ?
          (<StatefulUploadButtonForm
            fileList={toFileList(value)}
            disabled={readOnly}
            {...props}>
            Adjuntar documento
          </StatefulUploadButtonForm>
          ) : (
            <UploadButtonForm
              fileList={toFileList(value)}
              disabled={readOnly}
              {...props}>
              Adjuntar documento
            </UploadButtonForm>
          )
      }
    </div>
  )

  let tooltipButton = (
    <Button icon={<UploadOutlined />}>
      Adjuntar
    </Button>
  )

  if (small) {
    tooltipButton = (
      <Button
        shape="circle"
        icon={<PaperClipOutlined />} />
    )
  }

  if(isExpenseReconciliation){
    return(
      <Popover
      content={content}
      title={title}
      trigger="click">
      <Button shape="circle" icon={<FilePdfOutlined />}></Button>
    </Popover>
    )
  }

  return (
    <Popover
      content={content}
      title={title}
      trigger="click">
      {tooltipButton}
    </Popover>
  )
}
